export default function isEven(n){
    return n%2===0?true:false;
}